import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import genericAction from "@Actions/generic";

import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

import dataHandler from "@Utils/dataHandler";

import SurveyCrud from "./Modals/SurveyCrud";
import ConfirmModal from "@Modals/ConfirmModal";

import styles from "./styles.module.css";

const SurveyMaster = ({ dispatch, userName, companyName, currentCompanyId }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openSurveyCrud, setOpenSurveyCrud] = useState(false);
	const [modalOption, setModalOption] = useState("");
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const defaultParams = { page: 1, orderKey: "id", orderDir: "asc", rows: 15 };

	const mapSurveysWithXpressiLabel = (items = []) => {
		return items.map((item) => {
			const id = item.xpressiSurveyId;
			const name = item.xpressiSurveyName;

			let label = "xPressi Default";

			if (id) {
				if (name) {
					label = `${id} - ${name}`;
				} else {
					label = `${id} - xPressi Default`;
				}
			}

			return { ...item, xpressiSurveyLabel: label };
		});
	};

	useEffect(() => {
		(async () => {
			const surveyPromise = dataHandler({
				dispatch,
				url: "surveys",
				params: defaultParams,
			});
			const [surveyResponse] = await Promise.all([surveyPromise]);
			const items = mapSurveysWithXpressiLabel(surveyResponse?.items || []);
			setFilteredCount(surveyResponse?.count || 0);
			setFilteredItems(items);
		})();
	}, []);

	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenSurveyCrud(true);
	};

	const handleCloseSurveyCrud = (shouldRefresh) => {
		setOpenSurveyCrud(false);
		setTableValue({});
		setModalOption("");
		if (shouldRefresh) {
			refresh();
		}
	};

	const handleButton = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, {});
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const setRowStyle = (item) => {
		if (!item.isActive) {
			return { backgroundColor: "rgba(255, 0, 0, 0.24)" };
		}
		return null;
	};

	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "surveys", params });
		const items = mapSurveysWithXpressiLabel(data.items || []);
		if (printable) {
			setFilteredPrintData(items);
		} else {
			setFilteredItems(items);
			setFilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const surveyResponse = await dataHandler({
			dispatch,
			url: "surveys",
			params: defaultParams,
		});
		const items = mapSurveysWithXpressiLabel(surveyResponse.items || []);
		setFilteredCount(surveyResponse.count);
		setFilteredItems(items);
	};

	const apiData = async () => {
		setOpenConfirmModal(false);
		await dispatch(genericAction({ method: "delete", route: `surveys/${tableValue.id}` }));
		refresh();
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Configuración de Encuestas">
			<div className={styles.container}>
				<IkTable
					data={filteredItems}
					disabled={modalOption === "Watch"}
					columns={[
						{
							label: "Acciones",
							action: [
								{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
								{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
							],
							dataPosition: "center",
							width: 1,
							canFilter: false,
							canSort: false,
						},
						{
							label: "ID",
							key: "id",
							format: "string",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "Activo",
							key: "isActive",
							format: "boolean",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "ID Enc. Xpressi",
							key: "xpressiSurveyLabel",
							format: "string",
							dataPosition: "left",
							width: 3,
						},
						{
							label: "Flow ID",
							key: "flowId",
							format: "string",
							width: 1,
						},
						{
							label: "Título",
							key: "header",
							format: "string",
							width: 2,
						},
						{
							label: "Tipo Envío",
							key: "type",
							format: "string",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "Nombre Botón",
							key: "buttonCaption",
							format: "string",
							headerPosition: "left",
							width: 4,
						},
					]}
					totalRows={filteredCount}
					filteredPrintData={filteredPrintData}
					defaultParams={defaultParams}
					dataHandler={handlerData}
					handlerTable={handleButton}
					mobileCardView
					cardLine1={[
						{ key: "id", label: "ID" },
						{ key: "flowId", label: "Flow ID" },
						{ key: "header", label: "Header" },
					]}
					cardLine2={[
						{ key: "isActive", label: "Activo" },
						{ key: "xpressiSurveyLabel", label: "Enc. Xpressi" },
					]}
					addButton={{ label: "Agregar" }}
					searcher={{ width: "40rem", hideOnMobile: true }}
					setRowStyle={setRowStyle}
					print={{ printHeader: { company: companyName, title: "Encuestas", user: userName } }}
				/>
			</div>

			{openSurveyCrud && (
				<SurveyCrud
					onClose={handleCloseSurveyCrud}
					modalOption={modalOption}
					currentCompanyId={currentCompanyId}
					data={{ survey: tableValue }}
				/>
			)}

			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Eliminación"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar la encuesta"
					focus={`${tableValue.header}`}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		currentCompanyId: company.companyId,
	};
}

SurveyMaster.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	currentCompanyId: PropTypes.number,
	dispatch: PropTypes.func,
};

export default connect(mapStateToProps)(SurveyMaster);
